import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'video_call', namespaced: true })
export default class VideoCall extends VuexModule {
  public isVideoCall = false;

  get isActiveCall(): boolean {
    return this.isVideoCall;
  }

  @Mutation
  public SET_VIDEO_CALL(status: boolean): void {
    this.isVideoCall = status;
  }

  @Action
  public setVideoCall(status: boolean): void {
    this.context.commit('SET_VIDEO_CALL', status);
  }
}
